import React from "react";
import { Modal } from "react-bootstrap";
import Context from "../../Context";
import Blocker from "./Blocker";
import Flex from "./Flex";
import PriorityIcon from "./PriorityIcon";

export default class PriorityButton extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      modal: false,
      priorities: [],
    };
  }
  componentDidMount() {
    this.loadReferences();
  }

  loadReferences = async () => {
    this.setState({ pending: true });
    let priorities = await this.context.api.qac("/priority");
    this.setState({ pending: false, priorities: priorities || [] });
  };

  onChange = async (p) => {
    let saveData = {
      id: this.props.id,
      priority: p.id,
    };
    if (this.props.prepareData) {
      saveData = this.props.prepareData(p);
    }
    this.setState({ pending: true });
    let result = await this.context.api.q(this.props.setPath, saveData);
    if (result !== false) {
      this.setState({ modal: false });
      this.context.toast("Приоритет изменен", "success");
      if (this.props.onAfterChange) {
        this.props.onAfterChange(result);
      }
    } else {
      this.context.toast("Не удалось изменить приоритет", "error");
    }
    this.setState({ pending: false });
  };

  render() {
    const { pending, modal, priorities } = this.state;
    const { label, description, prioritycode } = this.props;

    return (
      <React.Fragment>
        <Modal
          size="sm"
          show={modal}
          onHide={() => this.setState({ modal: false })}
        >
          <Modal.Header closeButton>
            <div>
              <div className="font-weight-bold">{label}</div>
              {description && (
                <div className="text-muted small">{description}</div>
              )}
            </div>
          </Modal.Header>
          <Modal.Body>
            <Blocker on={pending} hAuto>
              <Flex between>
                {priorities.map((p) => (
                  <div
                    key={p.id}
                    onClick={() => this.onChange(p)}
                    title={`Приоритет: ${p.name}`}
                    className={`btn btn-icon btn-light btn-lg ${
                      prioritycode === p.code ? "bg-light-primary" : ""
                    }`}
                  >
                    <PriorityIcon
                      prioritycode={p.code}
                      priorityname={p.name}
                      showAll
                    />
                  </div>
                ))}
              </Flex>
            </Blocker>
          </Modal.Body>
        </Modal>
        <div
          onClick={() => this.setState({ modal: true })}
          className={this.props.className}
        >
          {this.props.priorityIcon}
        </div>
      </React.Fragment>
    );
  }
}
